import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M10.29 13.71a1.14 1.14 0 1 1 1.14-1.14 1.15 1.15 0 0 1-1.14 1.14Zm-3.43-1.14a1.15 1.15 0 1 0-1.14 1.14 1.14 1.14 0 0 0 1.14-1.14ZM11.43 8a1.15 1.15 0 1 0-1.14 1.14A1.15 1.15 0 0 0 11.43 8ZM6.86 8a1.15 1.15 0 1 0-1.14 1.14A1.15 1.15 0 0 0 6.86 8Zm4.57-4.57a1.15 1.15 0 1 0-1.14 1.14 1.14 1.14 0 0 0 1.14-1.14Zm-4.57 0a1.15 1.15 0 1 0-1.14 1.14 1.14 1.14 0 0 0 1.14-1.14Z';
const draw24px =
  'M14.29,20a1.15,1.15,0,1,1,1.14-1.14A1.14,1.14,0,0,1,14.29,20Zm-3.43-1.14A1.15,1.15,0,1,0,9.71,20,1.15,1.15,0,0,0,10.86,18.86Zm4.57-4.57a1.15,1.15,0,1,0-1.14,1.14A1.14,1.14,0,0,0,15.43,14.29Zm-4.57,0a1.15,1.15,0,1,0-1.15,1.14A1.14,1.14,0,0,0,10.86,14.29Zm4.57-4.58a1.15,1.15,0,1,0-1.14,1.15A1.14,1.14,0,0,0,15.43,9.71Zm-4.57,0a1.15,1.15,0,1,0-1.15,1.15A1.14,1.14,0,0,0,10.86,9.71Zm4.57-4.57a1.15,1.15,0,1,0-1.14,1.15A1.14,1.14,0,0,0,15.43,5.14Zm-4.57,0A1.15,1.15,0,1,0,9.71,6.29,1.14,1.14,0,0,0,10.86,5.14Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DragIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'drag'),
) as IconWithRender;

DragIcon.displayName = 'DragIcon';
DragIcon.propTypes = Icon.propTypes;
DragIcon.renderIcon = (props) => <DragIcon {...props} />;
export default DragIcon;
